













import { Component, Prop, Vue } from 'vue-property-decorator';
import Avatar from '../avatar';
import { IMentoringMember } from './types';

@Component({
  components: {
    Avatar,
  },
})
export default class MentoringMember extends Vue implements IMentoringMember {
  @Prop({ type: Boolean, default: false })
  readonly sidebarChild!: boolean;

  @Prop({ type: String, default: '' })
  readonly photo!: string;

  @Prop({ type: String, default: '' })
  readonly name!: string;

  @Prop({ type: String, default: '' })
  readonly lastname!: string;

  @Prop({ type: String, default: '' })
  readonly type!: string;

  @Prop({ type: Boolean, default: false })
  readonly asCurator!: boolean;

  @Prop({ type: String, default: 'N' })
  readonly gender!: string;

  get typeText(): string {
    return this.type.length
      ? this.type
      : this.sidebarChild
      ? 'вы'
      : 'наставляемый';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/components/member/MentoringMember.vue